import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient, ConvertParamsToFormData } from "~/utils";

import {
  ApiManagersKnowledgeInsightPostMutateType,
  PreviewWithFileType,
  RawDraftContentState,
} from "~/domains";

type RequestDataType = {
  id: string;
  body: {
    quotePostId?: string;
    content: RawDraftContentState;
    businessSectionIds: string[];
    attachFiles: PreviewWithFileType[];
    allBusinessSectionsDistribution: boolean;
  };
};

const request = ({ id, body }: RequestDataType) => {
  const formData = ConvertParamsToFormData({ knowledgeInsightPost: body });
  return new ApiClient()
    .put<ApiManagersKnowledgeInsightPostMutateType>(
      `/api/managers/knowledge_insight_posts/${id}`,
      formData,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisManagersKnowledgeInsightPostsUpdate = ({
  options = {},
}: PropsType = {}): UseMutationResult<
  ApiManagersKnowledgeInsightPostMutateType,
  RequestDataType
> => {
  return useMutation(request, { ...options });
};
